import React, { useState, useEffect } from "react";
import { Instagram, Menu, X, Sparkles, LogIn, UserCircle } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { contact } from "../mock";
import { useAuth } from "../context/AuthContext";

const links = [
  { label: "Course Finder", type: "route", to: "/course-finder" },
  { label: "Universities", type: "route", to: "/universities" },
  { label: "Higher Ed India", type: "route", to: "/higher-education" },
  { label: "Destinations", type: "route", to: "/destinations" },
  { label: "Counsellors", type: "route", to: "/counsellors" },
  { label: "For Schools", type: "route", to: "/school/register" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSection = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const goRoute = (to) => {
    setOpen(false);
    navigate(to);
  };

  const { user } = useAuth();

  return (
    <header
      className={`sticky top-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? "shadow-[0_6px_24px_-10px_rgba(22,36,79,0.35)]" : "shadow-[0_1px_0_0_rgba(0,0,0,0.05)]"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-5 flex items-center justify-between h-[74px]">
        <Logo />

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => (l.type === "section" ? goSection(l.id) : goRoute(l.to))}
              className="font-head text-[15px] font-medium text-[#16244F] hover:text-[#F58220] transition-colors relative after:absolute after:left-0 after:-bottom-1.5 after:h-[2px] after:w-0 after:bg-[#F58220] after:transition-all hover:after:w-full"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => goRoute("/assessment")}
            className="inline-flex items-center gap-1.5 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors"
          >
            <Sparkles size={16} /> Free Assessment
          </button>
          {user ? (
            <button
              onClick={() => goRoute("/account")}
              className="inline-flex items-center gap-1.5 border-2 border-[#16244F] text-[#16244F] hover:bg-[#16244F] hover:text-white font-head font-semibold text-sm px-3.5 py-2 rounded-lg transition-colors"
            >
              <UserCircle size={18} /> {user.name.split(" ")[0]}
            </button>
          ) : (
            <button
              onClick={() => goRoute("/login")}
              className="inline-flex items-center gap-1.5 border-2 border-[#16244F] text-[#16244F] hover:bg-[#16244F] hover:text-white font-head font-semibold text-sm px-3.5 py-2 rounded-lg transition-colors"
            >
              <LogIn size={16} /> Login
            </button>
          )}
          <a
            href={contact.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#16244F] hover:text-[#F58220] transition-colors"
            aria-label="Instagram"
          >
            <Instagram size={20} />
          </a>
        </nav>

        <button className="lg:hidden text-[#16244F]" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <nav className="flex flex-col px-6 py-3">
            {links.map((l) => (
              <button
                key={l.label}
                onClick={() => (l.type === "section" ? goSection(l.id) : goRoute(l.to))}
                className="text-left py-3 font-head text-[15px] font-medium text-[#16244F] hover:text-[#F58220] border-b border-gray-50"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => goRoute("/assessment")}
              className="mt-3 inline-flex items-center justify-center gap-1.5 bg-[#F58220] text-white font-head font-semibold px-4 py-3 rounded-lg"
            >
              <Sparkles size={16} /> Free Assessment
            </button>
            {user ? (
              <button onClick={() => goRoute("/account")} className="mt-3 inline-flex items-center justify-center gap-1.5 border-2 border-[#16244F] text-[#16244F] font-head font-semibold px-4 py-3 rounded-lg">
                <UserCircle size={18} /> My Account
              </button>
            ) : (
              <button onClick={() => goRoute("/login")} className="mt-3 inline-flex items-center justify-center gap-1.5 border-2 border-[#16244F] text-[#16244F] font-head font-semibold px-4 py-3 rounded-lg">
                <LogIn size={16} /> Login / Create Account
              </button>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
